import axios from 'axios';
import * as actionTypes from '../constants/actions';
import baseUrl from '../utils/baseUrl';

let url = baseUrl + '/api/jobs/';

function requestSingleData() {
	return { type: actionTypes.JOBS_REQ_DATA };
};

function requestSingleData() {
	return { type: actionTypes.JOBS_REQ_DATA_SINGLE };
};

function receiveData(json) {
	return {
		type: actionTypes.JOBS_RECV_DATA,
		payload: json,
	};
};

function receiveDataSingle(json) {
	return {
		type: actionTypes.JOBS_RECV_DATA_SINGLE,
		payload: json,
	};
};

function receiveError(json) {
	return {
		type: actionTypes.JOBS_RECV_ERROR,
		payload: json,
	};
};

export function fetchJobs(offset = 0, limit = 100) {
	return function(dispatch) {
		//dispatch(requestData());
		return axios({
			url: url,
			timeout: __TIMEOUT__ || 10000,
			method: 'get',
			responseType: 'json',
		})
		.then(function(response) {
			dispatch(receiveData(response.data));
		})
		.catch(function(response) {
			dispatch(receiveError(response.data));
		});
	};
};

export function fetchJob(slug, preview = false) {
	return function(dispatch) {
		//dispatch(requestSingleData());
		let data= {};

		if (preview) {
			data.preview = preview;
		}

		return axios({
			url: baseUrl + url + slug,
			timeout: __TIMEOUT__ || 10000,
			method: 'get',
			responseType: 'json',
			params: data,
		})
		.then(function(response) {
			dispatch(receiveDataSingle(response.data));
		})
		.catch(function(response) {
			dispatch(receiveError(response.data));
		});
	};
};



/** WEBPACK FOOTER **
 ** ./frontend/actions/jobs.js
 **/